import { render, staticRenderFns } from "./LEDPCBMagnetic.vue?vue&type=template&id=61903df6&scoped=true&"
import script from "./LEDPCBMagnetic.vue?vue&type=script&lang=js&"
export * from "./LEDPCBMagnetic.vue?vue&type=script&lang=js&"
import style0 from "./LEDPCBMagnetic.vue?vue&type=style&index=0&id=61903df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61903df6",
  null
  
)

export default component.exports